import { AuditMatch } from '../types';
import { usePlayAuditMatch as usePlayAuditMatchHook } from './useAuditPlayback';

export function usePlayAuditMatch(match: AuditMatch) {
  return usePlayAuditMatchHook(match);
}
